import { PackageIcon, ShoppingBagIcon, TruckIcon, TShirtIcon, UserCircleIcon } from '@phosphor-icons/react'

export const actionsMenuSections = [
  {
    label: 'Envío',
    Icon: PackageIcon,
    id: 'shipment',
  },
  {
    label: 'Pedido',
    Icon: ShoppingBagIcon,
    id: 'order',
  },
  {
    label: 'Cliente',
    Icon: UserCircleIcon,
    id: 'customer',
  },
  {
    label: 'Servicio de logística',
    Icon: TruckIcon,
    id: 'logisticService',
  },
  {
    label: 'Productos',
    Icon: TShirtIcon,
    id: 'products',
  },
]
